import { render, staticRenderFns } from "./DateBasedPageHeader.vue?vue&type=template&id=14387a82"
import script from "./DateBasedPageHeader.vue?vue&type=script&lang=js"
export * from "./DateBasedPageHeader.vue?vue&type=script&lang=js"
import style0 from "./DateBasedPageHeader.vue?vue&type=style&index=0&id=14387a82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports